import { HYDRATE } from 'next-redux-wrapper';

import { createSlice, createAsyncThunk, createAction } from '@reduxjs/toolkit';
import { getReq } from 'api';

const hydrate = createAction(HYDRATE);

// async thunks
export const fetchCurrentUserProfile = createAsyncThunk(
    'currentUser/fetchProfile',
    async (slug, { rejectWithValue }) => {
        try {
            const res = await getReq(`/profiles/slug/${slug}`);
            return res.data.data;
        } catch (err) {
            let error = err;
            if (!error.response) {
                throw err;
            }
            return rejectWithValue(error.response.data);
        }
    }
);

const initialState = {
    profile: null,
    loading: false,
    error: null,
};

const currentUserSlice = createSlice({
    name: 'currentUser',
    initialState,
    reducers: {
        resetCurrentUser: () => initialState,
    },
    extraReducers(builder) {
        builder
            .addCase(hydrate, (state, action) => {
                return {
                    ...state,
                    ...action.payload?.currentUser,
                };
            })
            .addCase(fetchCurrentUserProfile.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(
                fetchCurrentUserProfile.fulfilled,
                (state, { payload }) => {
                    state.profile = payload;
                    state.loading = false;
                }
            )
            .addCase(fetchCurrentUserProfile.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
            });
    },
});

export const { resetCurrentUser } = currentUserSlice.actions;

export const currentUserSelector = ({ currentUser }) => currentUser;

export default currentUserSlice.reducer;
